<button
  type="button"
  class="doc-type-chip"
  [class.doc-type-chip--compact]="size === 'compact'"
  [class.doc-type-chip--active]="active"
  [class.doc-type-chip--has-selection]="hasSelection && !active"
  [style.--chip-accent]="color"
  (click)="toggle.emit()"
>
  @if (color) {
    <span class="doc-type-chip__dot" aria-hidden="true"></span>
  }
  <span class="doc-type-chip__label">{{ label }}</span>
  @if (countLabel) {
    <span class="doc-type-chip__count" [class.doc-type-chip__count--selected]="hasSelection">{{ countLabel }}</span>
  }
</button>
